import React, { createContext, FC, useEffect, useState } from "react";
import { ThemeProvider } from "@material-ui/core/styles";

import {
  DEFAULT_THEME,
  THEME_CLASSNAME_SUFFIX,
  THEME_NAME,
  ThemeColorSet,
} from "./../themes/theme";
import { getTheme } from "./../themes";
import { themesColors } from "./../themes/colorVariables";
import { GlobalStyles } from "themes/GlobalStyles";

type ThemeContextProps = {
  currentTheme: THEME_NAME;
  currentColors: ThemeColorSet;
  setTheme: (name: THEME_NAME) => void;
};

export const CustomThemeContext = createContext<ThemeContextProps>({
  currentTheme: DEFAULT_THEME,
  currentColors: themesColors[DEFAULT_THEME],
  setTheme: null,
});

export const CustomThemeProvider: FC = ({ children }) => {
  const [themeName, _setThemeName] = useState(DEFAULT_THEME);
  const [theme, _setTheme] = useState(getTheme(DEFAULT_THEME));
  const [themeColors, _setThemeColors] = useState(themesColors[DEFAULT_THEME]);

  useEffect(() => {
    if (typeof themesColors[themeName] !== "undefined") {
      _handleSetTheme(themeName);
    }
  }, [themeName]);

  const _handleSetTheme = (themeName: THEME_NAME) => {
    const bodyClasses = document.body.classList;

    bodyClasses.forEach((name) => {
      if (name.endsWith(THEME_CLASSNAME_SUFFIX)) {
        bodyClasses.remove(name);
      }
    });

    bodyClasses.add(`${themeName}${THEME_CLASSNAME_SUFFIX}`);
    _setTheme(getTheme(themeName));
    _setThemeColors(themesColors[themeName]);
  };

  const setThemeName = (name: THEME_NAME) => _setThemeName(name);

  const contextValue: ThemeContextProps = {
    currentTheme: themeName,
    currentColors: themeColors,
    setTheme: setThemeName,
  };

  return (
    <CustomThemeContext.Provider value={contextValue}>
      <GlobalStyles />
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </CustomThemeContext.Provider>
  );
};
